import { UserResponseDtoRoleEnum } from '@app/api';

import React, { FC, ReactNode, useMemo } from 'react';
import { BaseLayout } from '../BaseLayout';
import { useRouter } from 'next/router';

interface AuthLayoutProps {
  children?: ReactNode;
  role?: UserResponseDtoRoleEnum;
}

const AuthLayout: FC<AuthLayoutProps> = ({
  children,
  role,
}) => {
  const router = useRouter();
  
  const isInterviewPage = useMemo(() => {
    return router.pathname.includes('/interview');
  }, [router]);

  return (
    <>
      <BaseLayout
        role={role}
        showCommonLinks={true}
        hasHeader={!isInterviewPage}
      >
        {children}
      </BaseLayout>
    </>
  );
};

export default AuthLayout;

export const getAuthLayout = (page: ReactNode, props?: AuthLayoutProps) => {
  return <AuthLayout {...props}>{page}</AuthLayout>;
};
